export const WEBSITE_MENU_SEARCH = 'WEBSITE_MENU_SEARCH';
export const WEBSITE_MENU_DETAIL = 'WEBSITE_MENU_DETAIL';
export const WEBSITE_MENU_ITEM_GETALL = 'WEBSITE_MENU_ITEM_GETALL';
export const WEBSITE_MENU_ITEM_SEARCH = 'WEBSITE_MENU_ITEM_SEARCH';
export const WEBSITE_MENU_ITEM_TREE = 'WEBSITE_MENU_ITEM_TREE';
export const WEBSITE_MENU_ITEM_DETAIL = 'WEBSITE_MENU_ITEM_DETAIL';
export const WEBSITE_MENU_ITEM_UPDATE_ACTIVE = 'WEBSITE_MENU_ITEM_UPDATE_ACTIVE';
